import React from 'react'
import utils from './utils'

function getLevelLayout(width, height, settings, quantities, answer) {

    if (settings.commutative) {
        if (settings.answer_required === 'value_1') {
            settings.answer_required = 'value_2'
        } else if (settings.answer_required === 'value_2') {
            settings.answer_required = 'value_1'
        }
    }
    return (
        <svg
            height={height}
            width={width}
        >
            {getLayout(width, height, settings, quantities, answer)}
        </svg>
    )
}

function getLayout(width, height, settings, quantities, answer) {
    const values = getValues(quantities.value_1, quantities.value_2, answer, settings)
    if (settings.operation === 'addition') {
        return getAdditionLayout(width, height, settings, values, quantities)
    } else {
        return getSubtractionLayout(width, height, settings, values, quantities)
    }

}

function getAdditionLayout(width, height, settings, values, quantities) {
    const gameContainerWidth = width
    const gameContainerHeight = height
    const value_1 = quantities.value_1
    const value_2 = quantities.value_2
    const hideAnswerBar = settings.hide_answer_bar
    const gridBgWidth = 300
    const gridBgHeight = hideAnswerBar ? 117 : 177
    const showDots = settings.show_dots
    const coloredFill = settings.colored_fill
    const barWidth = gridBgWidth / (+value_1 + +value_2)

    let answerBarWidth = gridBgWidth
    let val1BarWidth = settings.show_proportionate ? barWidth * value_1 : gridBgWidth / 2
    let val2BarWidth = settings.show_proportionate ? barWidth * value_2 : gridBgWidth / 2

    let scale = 0

    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }

    let answerBar = null
    let val1Bar = null
    let val2Bar = null

    if (settings.show_answer_grid) {
        let bars = []
        for (let i = 0; i < +value_1 + +value_2; i++) {
            bars.push(
                showDots ?
                    utils.getBarWithBolt(i * barWidth, 25, barWidth, 60, 'gold')
                    : utils.getBar(i * barWidth, 25, barWidth, 60, (coloredFill ? '#e94e1b' : '#b8cbdb'), (coloredFill ? true : false))
            )
        }
        answerBar = (
            <g>
                {bars.map(value => value)}
            </g>
        )
    } else {
        answerBar = showDots ?
            utils.getBarWithBolt(0, 25, answerBarWidth, 60, 'gold')
            : utils.getBar(0, 25, answerBarWidth, 60, (coloredFill ? '#e94e1b' : '#b8cbdb'), (coloredFill ? true : false))
    }

    if (settings.show_value_1_grid && settings.show_proportionate) {
        let bars = []
        for (let i = 0; i < +value_1; i++) {
            bars.push(
                showDots ?
                    utils.getBarWithBolt(i * barWidth, (hideAnswerBar ? 25 : 85), barWidth, 60,(settings.commutative ? 'copper' : 'silver'))
                    : utils.getBar(i * barWidth, (hideAnswerBar ? 25 : 85), barWidth, 60, (coloredFill ? (settings.commutative ? '#fab833' : '#009fe3') : '#b8cbdb'), (coloredFill ? true : false))
            )
        }
        val1Bar = (
            <g>
                {bars.map(value => value)}
            </g>
        )
    } else {
        val1Bar = showDots ?
            utils.getBarWithBolt(0, (hideAnswerBar ? 25 : 85), val1BarWidth, 60, (settings.commutative ? 'copper' : 'silver'))
            : utils.getBar(0, (hideAnswerBar ? 25 : 85), val1BarWidth, 60, (coloredFill ? (settings.commutative ? '#fab833' : '#009fe3') : '#b8cbdb'), (coloredFill ? true : false))
    }

    if (settings.show_value_2_grid && settings.show_proportionate) {
        let bars = []
        for (let i = 0; i < +value_2; i++) {
            bars.push(
                showDots ?
                    utils.getBarWithBolt(val1BarWidth + i * barWidth, (hideAnswerBar ? 25 : 85), barWidth, 60, (!settings.commutative ? 'copper' : 'silver'))
                    : utils.getBar(val1BarWidth + i * barWidth, (hideAnswerBar ? 25 : 85), barWidth, 60, (coloredFill ? (!settings.commutative ? '#fab833' : '#009fe3') : '#b8cbdb'), (coloredFill ? true : false))
            )
        }
        val2Bar = (
            <g>
                {bars.map(value => value)}
            </g>
        )
    } else {
        val2Bar = showDots ?
            utils.getBarWithBolt(val1BarWidth, (hideAnswerBar ? 25 : 85), val2BarWidth, 60, (!settings.commutative ? 'copper' : 'silver'))
            : utils.getBar(val1BarWidth, (hideAnswerBar ? 25 : 85), val2BarWidth, 60, (coloredFill ? (!settings.commutative ? '#fab833' : '#009fe3') : '#b8cbdb'), (coloredFill ? true : false))
    }

    return (
        <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale) / 2}), scale(${scale})`}>
            <g transform={`translate(0, 7)`}>
                <path d="M 2.0800781 0.005859375 C 0.90407812 0.005859375 0 0.91189062 0 2.0878906 A 2.048 2.048 0 0 0 0 2.0957031 L 0 11.136719 A 2.048 2.048 0 0 0 2.0800781 13.21875 C 3.1660781 13.21875 4.1621094 12.312563 4.1621094 11.226562 L 4.1621094 4.1699219 L 132.2168 4.1699219 A 2.048 2.048 0 0 0 134.29883 2.0878906 C 134.29883 0.91189062 133.3028 -0.084140625 132.2168 0.005859375 L 2.0800781 0.005859375 z M 167.7832 0.005859375 C 166.6062 -0.084140625 165.70117 0.91189062 165.70117 2.0878906 C 165.70117 3.2648906 166.6062 4.1699219 167.7832 4.1699219 L 295.83789 4.1699219 L 295.83789 11.226562 C 295.83789 12.312563 296.74197 13.21875 297.91797 13.21875 A 2.048 2.048 0 0 0 300 11.136719 L 300 2.0957031 A 2.048 2.048 0 0 0 300 2.0878906 A 2.048 2.048 0 0 0 297.91797 0.005859375 L 167.7832 0.005859375 z " opacity=".2" fill="#fff" />
            </g>
            {!hideAnswerBar && answerBar}
            {val1Bar}
            {val2Bar}

            {values[0] !== 0 && <text
                fill="white"
                fontSize={18}
                fontWeight="regular"
                x={val1BarWidth / 2}
                y={settings.show_value_1_grid || settings.show_dots ? gridBgHeight - 8 : gridBgHeight - 56}
                textAnchor="middle"
            >{values[0]}</text>}
            {values[1] !== 0 && <text
                fill="white"
                fontSize={18}
                fontWeight="regular"
                x={val1BarWidth + val2BarWidth / 2}
                y={settings.show_value_2_grid || settings.show_dots ? gridBgHeight - 8 : gridBgHeight - 56}
                textAnchor="middle"
            >{values[1]}</text>}
            <text
                fill="white"
                fontSize={18}
                fontWeight="regular"
                x={gridBgWidth / 2}
                y={15}
                textAnchor="middle"
            >{values[2]}</text>

        </g>
    )
}

function getSubtractionLayout(width, height, settings, values, quantities) {
    const gameContainerWidth = width
    const gameContainerHeight = height
    const value_1 = quantities.value_1
    const value_2 = quantities.value_2
    const hideAnswerBar = settings.hide_answer_bar
    const gridBgWidth = 300
    const gridBgHeight = hideAnswerBar ? 117 : 177
    const showDots = settings.show_dots
    const coloredFill = settings.colored_fill
    const barWidth = gridBgWidth / value_1

    let answerBarWidth = settings.show_proportionate ? barWidth * (value_1 - value_2) : gridBgWidth / 2
    let val1BarWidth = gridBgWidth
    let val2BarWidth = settings.show_proportionate ? barWidth * value_2 : gridBgWidth / 2

    let scale = 0

    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }

    let answerBar = null
    let val1Bar = null
    let val2Bar = null

    if (settings.show_value_1_grid) {
        let bars = []
        for (let i = 0; i < +value_1; i++) {
            bars.push(
                showDots ?
                    utils.getBarWithBolt(i * barWidth, 25, barWidth, 60, 'gold')
                    : utils.getBar(i * barWidth, 25, barWidth, 60, (coloredFill ? '#e94e1b' : '#b8cbdb'), (coloredFill ? true : false))
            )
        }
        val1Bar = (
            <g>
                {bars.map(value => value)}
            </g>
        )
    } else {
        val1Bar = showDots ?
            utils.getBarWithBolt(0, 25, val1BarWidth, 60, 'gold')
            : utils.getBar(0, 25, val1BarWidth, 60, (coloredFill ? '#e94e1b' : '#b8cbdb'), (coloredFill ? true : false))
    }

    if (settings.show_value_2_grid && settings.show_proportionate) {
        let bars = []
        for (let i = 0; i < +value_2; i++) {
            bars.push(
                showDots ?
                    utils.getBarWithBolt(i * barWidth, (hideAnswerBar ? 25 : 85), barWidth, 60, 'silver')
                    : utils.getBar(i * barWidth, (hideAnswerBar ? 25 : 85), barWidth, 60, (coloredFill ? '#009fe3' : '#b8cbdb'), (coloredFill ? true : false))
            )
        }
        val2Bar = (
            <g>
                {bars.map(value => value)}
            </g>
        )
    } else {
        val2Bar = showDots ?
            utils.getBarWithBolt(0, (hideAnswerBar ? 25 : 85), val2BarWidth, 60, 'silver')
            : utils.getBar(0, (hideAnswerBar ? 25 : 85), val2BarWidth, 60, (coloredFill ? '#009fe3' : '#b8cbdb'), (coloredFill ? true : false))
    }

    if (settings.show_answer_grid && settings.show_proportionate) {
        let bars = []
        for (let i = 0; i < value_1 - value_2; i++) {
            bars.push(
                showDots ?
                    utils.getBarWithBolt(val2BarWidth + i * barWidth, (hideAnswerBar ? 25 : 85), barWidth, 60, 'copper')
                    : utils.getBar(val2BarWidth + i * barWidth, (hideAnswerBar ? 25 : 85), barWidth, 60, (coloredFill ? '#fab833' : '#b8cbdb'), (coloredFill ? true : false))
            )
        }
        answerBar = (
            <g>
                {bars.map(value => value)}
            </g>
        )
    } else {
        answerBar = showDots ?
            utils.getBarWithBolt(val2BarWidth, (hideAnswerBar ? 25 : 85), answerBarWidth, 60, 'copper')
            : utils.getBar(val2BarWidth, (hideAnswerBar ? 25 : 85), answerBarWidth, 60, (coloredFill ? '#fab833' : '#b8cbdb'), (coloredFill ? true : false))
    }

    return (
        <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale) / 2}), scale(${scale})`}>
            <g transform={`translate(0, 7)`}>
                <path d="M 2.0800781 0.005859375 C 0.90407812 0.005859375 0 0.91189062 0 2.0878906 A 2.048 2.048 0 0 0 0 2.0957031 L 0 11.136719 A 2.048 2.048 0 0 0 2.0800781 13.21875 C 3.1660781 13.21875 4.1621094 12.312563 4.1621094 11.226562 L 4.1621094 4.1699219 L 132.2168 4.1699219 A 2.048 2.048 0 0 0 134.29883 2.0878906 C 134.29883 0.91189062 133.3028 -0.084140625 132.2168 0.005859375 L 2.0800781 0.005859375 z M 167.7832 0.005859375 C 166.6062 -0.084140625 165.70117 0.91189062 165.70117 2.0878906 C 165.70117 3.2648906 166.6062 4.1699219 167.7832 4.1699219 L 295.83789 4.1699219 L 295.83789 11.226562 C 295.83789 12.312563 296.74197 13.21875 297.91797 13.21875 A 2.048 2.048 0 0 0 300 11.136719 L 300 2.0957031 A 2.048 2.048 0 0 0 300 2.0878906 A 2.048 2.048 0 0 0 297.91797 0.005859375 L 167.7832 0.005859375 z " opacity=".2" fill="#fff" />
            </g>
            {answerBar}
            {!hideAnswerBar && val1Bar}
            {val2Bar}

            {values[2] !== 0 && <text
                fill="white"
                fontSize={18}
                fontWeight="regular"
                x={val2BarWidth + answerBarWidth / 2}
                y={settings.show_answer_grid || settings.show_dots ? gridBgHeight - 8 : gridBgHeight - 56}
                textAnchor="middle"
            >{values[2]}</text>}
            {values[1] !== 0 && <text
                fill="white"
                fontSize={18}
                fontWeight="regular"
                x={val2BarWidth / 2}
                y={settings.show_value_2_grid || settings.show_dots ? gridBgHeight - 8 : gridBgHeight - 56}
                textAnchor="middle"
            >{values[1]}</text>}
            <text
                fill="white"
                fontSize={18}
                fontWeight="regular"
                x={gridBgWidth / 2}
                y={15}
                textAnchor="middle"
            >{values[0]}</text>

        </g>
    )
}

function getLayoutSettings(gameContainerWidth, gameContainerHeight) {

    /* const gameContainerMargin = gameContainerWidth * .04

    if (gameContainerWidth * 0.6 > gameContainerHeight) {
        gameContainerWidth = gameContainerHeight / 0.6 - gameContainerMargin
        gameContainerHeight = gameContainerHeight - gameContainerMargin
    } else {
        gameContainerWidth = gameContainerWidth - gameContainerMargin
        gameContainerHeight = gameContainerWidth * 0.6 - gameContainerMargin
    } */

    const sideMargin = 0//gameContainerWidth * .05
    const marginBottom = gameContainerWidth * .1
    const lineWeight = gameContainerWidth / 150
    const arrowSize = gameContainerWidth / 35
    const fontSize = gameContainerWidth / 15

    const rectHeight = gameContainerWidth * 1.7
    const rectWidth = gameContainerWidth

    return {
        gameContainerWidth,
        gameContainerHeight,
        sideMargin,
        rectWidth,
        rectHeight,
        marginBottom,
        lineWeight,
        arrowSize,
        fontSize
    }
}

function getValues(value_1, value_2, answer, settings) {
    const operation = settings.operation
    const answerRequired = settings.answer_required || 'answer'
    if (settings.show_tens) {
        if (operation === 'addition') {
            if (answerRequired === 'value_1') {
                answer = utils.isPowerOfTen(value_1) ? answer + ' tens' : answer
                return [answer, utils.getTens(value_2), utils.getTens(+value_1 + +value_2)]
            } else if (answerRequired === 'value_2') {
                answer = utils.isPowerOfTen(value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), answer, utils.getTens(+value_1 + +value_2)]
            } else if (answerRequired === 'answer') {
                answer = utils.isPowerOfTen(+value_1 + +value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), answer]
            } else {
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(+value_1 + +value_2)]
            }
        } else {
            if (answerRequired === 'value_1') {
                answer = utils.isPowerOfTen(value_1) ? answer + ' tens' : answer
                return [answer, utils.getTens(value_2), utils.getTens(value_1 - value_2)]
            } else if (answerRequired === 'value_2') {
                answer = utils.isPowerOfTen(value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), answer, utils.getTens(value_1 - value_2)]
            } else if (answerRequired === 'answer') {
                answer = utils.isPowerOfTen(value_1 - value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), answer]
            } else {
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_1 - value_2)]
            }
        }
    } else {
        if (operation === 'addition') {
            if (answerRequired === 'value_1') {
                return [answer, value_2, +value_1 + +value_2]
            } else if (answerRequired === 'value_2') {
                return [value_1, answer, +value_1 + +value_2]
            } else if (answerRequired === 'answer') {
                return [value_1, value_2, answer]
            } else {
                return [value_1, value_2, +value_1 + +value_2]
            }
        } else {
            if (answerRequired === 'value_1') {
                return [answer, value_2, value_1 - value_2]
            } else if (answerRequired === 'value_2') {
                return [value_1, answer, value_1 - value_2]
            } else if (answerRequired === 'answer') {
                return [value_1, value_2, answer]
            } else {
                return [value_1, value_2, value_1 - value_2]
            }
        }
    }
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/barModel.utils.js